import { useCallback } from 'react';

import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedKiloClassPayRateLookupList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
}

interface IUseClassPayRateLookups {
  ordering?: string;
  staff: string;
  limit?: string;
}

function useClassPayRateLookups({
  ordering,
  staff,
  limit = '20',
}: IUseClassPayRateLookups): UseInfiniteQueryResult<AxiosResponse<PaginatedKiloClassPayRateLookupList>> {
  const fetchClassPayRateLookups = useCallback(
    ({
      pageParam = { limit, offset: '0' },
    }: QueryKeyType): Promise<AxiosResponse<PaginatedKiloClassPayRateLookupList>> => {
      const params = pageParam;
      if (ordering) {
        params.ordering = ordering.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`).concat(',pk');
      }
      if (staff) {
        params.staff = staff;
      }
      return client.get(`kilo-class-pay-rate-lookups/?${encodeUrlParams(pageParam)}`);
    },
    [limit, ordering, staff],
  );

  return useInfiniteQuery(['classPayRateLookups', ordering, staff], fetchClassPayRateLookups, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
    enabled: !!staff,
  });
}

export default useClassPayRateLookups;
